import * as React from "react";
import Divider from "@mui/material/Divider";

import DashboardSidebarContext, {
  DashboardSidebarContextValue,
} from "./DashboardSidebarContext";
import { getDrawerSxTransitionMixin } from "./mixins";

export default function DashboardSidebarDividerItem(): React.JSX.Element {
  const sidebarContext = React.useContext<DashboardSidebarContextValue | null>(
    DashboardSidebarContext,
  );
  if (!sidebarContext) {
    throw new Error("Sidebar context was used without a provider.");
  }
  const { fullyExpanded = true, hasDrawerTransitions } = sidebarContext;

  return (
    <li>
      <Divider
        sx={{
          borderBottomWidth: 1,
          my: 1,
          mx: -0.5,
          ...(hasDrawerTransitions
            ? getDrawerSxTransitionMixin(fullyExpanded, "margin")
            : {}),
        }}
      />
    </li>
  );
}
